export const LANGUAGE = {
  EN: 'en',
  SV: 'sv',
} as const

export const LANGUAGE_LOCALE = {
  EN: 'en-US',
  SV: 'sv-SE',
} as const
